import React from 'react'
import useSnackbar from 'hooks/useSnackbar'

import {
  Button,
  Dialog,
  Divider,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from '@material-ui/core'

import * as service from 'service'

const DialogInvoiceResend = ({
  open,
  setOpen,
  invoiceId,
  contractId,
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()

  const onSubmit = async () => {
    try {
      await service.recurrence.invoices.resend({
        contractId,
        invoiceId,
      })

      snackbar.open({
        message: 'Cobrança reenviada com sucesso!',
        variant: 'success',
      })

      onEvent(true)
      setOpen(false)
    } catch {
      snackbar.open({
        message: 'Falha ao reenviar link de pagamento!',
        variant: 'error',
      })
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography variant="h3">Reenviar link de pagamento</Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText align="justify">
          Atenção! Um email com o link de pagamento será enviado ao cliente.
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions p={2}>
        <Button variant="contained" color="primary" onClick={() => onSubmit()}>
          Confirmar
        </Button>
        <Button
          onClick={() => setOpen(false)}
          variant="outlined"
          color="primary"
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogInvoiceResend
